import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import IncidentalDepositPresenterGeneral from "./tabs/IncidentalDepositPresenterGeneral";
import Tabs from '../Tabs/Tabs';
import IncidentalDepositPresenterTabContent from "./IncidentalDepositPresenterTabContent";

class IncidentalDepositPresenter extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      active_tab: 'general',
      incidental_deposit: this.props.incidental_deposit,
      all_room_types: this.props.all_room_types,
      maintain_authorization: this.props.incidental_deposit.reauthorize ? true : false,
      incidental_deposit_revision_history_path: this.props.incidental_deposit_revision_history_path,
      time_format: this.props.time_format,
      date_format: this.props.date_format,
      historical_view: this.props.historical_view

    }
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
    this.onChangeRevertVersion = this.onChangeRevertVersion.bind(this)
  }

  componentDidMount() {
    var self = this
    $(window).on("incidentalDepositSaved", function () {
      $.ajax({
        type: 'POST',
        url: `/admin/incidental_deposits/${self.props.incidental_deposit.id}/data`,
      }).done((data) => {
        self.setState({...data});
      })
    });
  }

  render() {
    var buttons = [
      {
        name: I18n.t('ok'),
        html_attributes: [
            'data-dismiss="modal"'
        ]
      },
    ]
    
    return(
      <div className="incidental-deposit-builder">
        <div className="panel panel-form">
          { this.props.hideModalButtons ? null : <ModalButtons loading={this.state.loading} buttons={buttons} />}
          { this.props.nested 
              ? <IncidentalDepositPresenterGeneral {...this.props} {...this.state}/> 
              : <div>
                  <Tabs tabs={this.tabs()} />
                  <IncidentalDepositPresenterTabContent {...this.state} />
                </div>
          }
        </div>
      </div>
    );
  };

  tabs() {
    if(this.props.historical_view == true) {
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          // {
          //   tabName: I18n.t('room_types'),
          //   targetName: 'room-types',
          //   classes: this.state.active_tab === 'room-types' ? 'active' : null,
          //   changeHandler: this.onChangeActiveTab,
          // },
  
        ]
      )
    } else {
      return (
        
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('room_types'),
            targetName: 'room-types',
            classes: this.state.active_tab === 'room-types' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('history'),
            targetName: 'history',
            classes: this.state.active_tab === 'history' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      );
    }

  };

  onChangeRevertVersion() {
    var self = this
    $.ajax({
      type: 'POST',
      url: `/admin/incidental_deposits/${this.props.incidental_deposit.id}/version/${this.props.versions.id}/revert`,
    }).done((data) => {
      window.parent.$(window.parent).trigger('incidentalDepositSaved');
      this.setState({loading: false});
      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t('record_reverted_successfully'));
      }
      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }
    })
  }

  onChangeActiveTab(active_tab) {
    this.setState({
      active_tab: active_tab
    });
  };
};

export default IncidentalDepositPresenter